<template>
    <v-dialog
            :value="chatClaudia"
            @input="$emit('cerrar')"
            max-width="900px"
            persistent
            scrollable
            
        >
            <v-card style="min-height: 500px; max-height: 500px;">
                <v-card-title style="background-color: #009fc31c; padding-top: 4px; padding-bottom: 4px;">
                    <v-avatar class="mr-2">
                        <img src="img/claudia.png" alt="Claudia" />
                    </v-avatar>
                    <span class="ai" style="font-size: 14px;">Claudia</span><v-icon small class="ai mr-2">mdi-creation</v-icon>
                    <v-menu v-if="tematica" offset-y disabled>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                color="info"
                                v-bind="attrs"
                                v-on="on"
                                x-small
                                outlined
                                style="text-transform: none !important;"
                            >
                                {{ tematica }}
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item
                                v-for="(item, index) in tematicas" :key="index"
                                @click="cambiarTematica(item)"
                            >
                                {{ item }}
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <div class="wave ml-2" v-if="loading">
                        <span class="dot"></span>
                        <span class="dot"></span>
                        <span class="dot"></span>
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn 
                        icon
                        @click="$emit('cerrar')"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text id="messagesContainer" style="background-color: #009fc31c;">
                    <v-container fluid>
                        <v-layout column>
                            <v-card 
                                v-for="(message, index) in messages" 
                                :key="index" 
                                :class="{ 'usermsg': message.role === 'user', 'claudiamsg': message.role !== 'user' }" 
                                class="mb-2 msganimation"  
                            >
                                <v-card-text v-if="!message.isChoice" style="padding-bottom: 5px; padding-top: 5px;">{{ message.content }}</v-card-text>
                                <v-card-text v-else style="padding-bottom: 5px; padding-top: 5px;">
                                    <v-btn 
                                        v-for="(choice, index) in message.content"
                                        @click="selectChoice(choice)"
                                        class="mr-2"
                                        small
                                        color="info"
                                        outlined
                                    >
                                        {{ choice }}
                                    </v-btn>
                                </v-card-text>
                            </v-card>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-divider class="mb-2"></v-divider>
                <v-card-actions>
                    <v-text-field
                        v-model="usermsg"
                        outlined
                        label="Mensaje"
                        :append-icon="!loading ? 'mdi-send' : 'mdi-comment-processing-outline'"
                        rows="2"
                        dense
                        hide-details
                        @click:append="send"
                        @keydown.enter="send"
                        autofocus
                    >
                    </v-text-field>
                </v-card-actions>
            </v-card>
        </v-dialog>
</template>

<script>
    import { mapState } from 'vuex';
    import { peticionInforme } from '@/api/claudia'
    export default {
        name: "ChatClaudia",
        components: {
            
        },
        data() {
            return {
                loading: false,
                tematica: 'Informes', //null
                tematicas: ['Informes', 'Tareas programadas'],
                usermsg: '',
                messages: []
            }
        },
        props: {
            chatClaudia: {
                type: Boolean,
                required: true,
            }
        },
        mounted(){
            
        },
        methods: {
            send(){
                if(this.usermsg.length > 0 && !this.loading){
                    this.addMessage({
                        content: this.usermsg,
                        role: 'user'
                    })
                    if(this.tematica === null){
                        // Verificamos si el texto proporcionado por el usuario forma parte de una de las temáticas disponibles
                        if(this.tematicas.find(tematica => tematica.toLowerCase() === this.usermsg.toLowerCase()) !== undefined){ 
                            this.tematica = this.usermsg
                            this.addMessage({
                                content: '¡De acuerdo! Dime, ¿qué necesitas?',
                                role: 'assistant'
                            }
                            )
                        }else{
                            this.addMessage({
                                content: 'Por el momento estoy programada para atender solicitudes para uno de estos temas:',
                                role: 'assistant'
                            }
                            )
                            this.addMessage({
                                content: this.tematicas,
                                role: 'assistant',
                                isChoice: true
                            })
                        }
                    }else{
                        setTimeout( () => {
                            this.addMessage({
                                content: '¡Perfecto! Dame unos instantes, tengo que revisar varias cosas 🤔.',
                                role: 'assistant'
                            })
                            setTimeout( () => {
                                if(this.loading){
                                    this.addMessage({
                                        content: 'Sigo en ello... Ten un poco de paciencia 🥺.',
                                        role: 'assistant'
                                    })
                                }
                            }, 40000)
                        }, 500)
                        switch (this.tematica.toLowerCase()) {
                            case 'informes':
                                this.loading = true
                                peticionInforme(this.usermsg).then(respuesta => {
                                    this.addMessage({
                                        content: respuesta.data.mensaje,
                                        role: 'assistant'
                                    })
                                    if(respuesta.data.chart !== undefined){
                                        // console.log(respuesta.data.query)
                                        let chart = respuesta.data.chart;
                                        chart.nuevo = true;
                                        this.$emit('insertGeneratedChart', chart)
                                    }
                                }).finally(() => {
                                    this.loading = false
                                })
                                break;
                            case 'tareas programadas':
                                console.log('En desarrollo')
                                break;
                        }
                    }
                    this.usermsg = ''
                }
            },
            saludo(){
                this.loading = true
                this.messages = []
                this.addMessage({
                    content: '¡Hola, '+this.authUser?.name+'! ¿En qué puedo ayudarte?',
                    role: 'assistant'
                })
                if(!this.tematica){
                    this.addMessage({
                        content: this.tematicas,
                        role: 'assistant',
                        isChoice: true
                    })
                }
                this.loading = false
            },
            addMessage(data){
                this.messages.push(data)
                this.$nextTick(function () {
                    let messagesContainer = document.getElementById('messagesContainer');
                    if(messagesContainer !== null) messagesContainer.scrollTop = messagesContainer.scrollHeight;
                })
            },
            selectChoice(choice){
                this.usermsg = choice
                this.send()
                this.messages.splice(1,1) // eliminamos el mensaje de selección de temática
            },
            cambiarTematica(tematica){
                this.tematica = null
                this.saludo()
                this.selectChoice(tematica)
            },
            typingEffect(){
                // if(this.posicion < this.textoBienvenida.length){
                //     if(this.textoBienvenida.charAt(this.posicion) === '<'){
                //         this.writingHTML = true
                //     }
                //     if(this.textoBienvenida.charAt(this.posicion) === '>'){
                //         this.writingHTML = false
                //     }
                //     if(!this.writingHTML){
                //         this.bienvenida += this.textoBienvenida.charAt(this.posicion)
                //         this.posicion++
                //         setTimeout(this.typingEffect, this.velocidadEscritura)
                //     }else{
                //         this.bienvenida += this.textoBienvenida.charAt(this.posicion)
                //         this.posicion++
                //         this.typingEffect()
                //     }
                // }
            }
        },
        watch: {
            chatClaudia(){
                if(this.chatClaudia){
                    this.saludo()
                }else{
                    this.tematica = 'Informes' // null
                    this.messages = []
                }
            }
        },
        computed: {
            ...mapState("login", ["authUser"]),
        }
    }
</script>
<style>
    .ai{
      animation: rainbow 4s linear infinite;
      background-image: linear-gradient(90deg,#00e6e6,#0059ff,#00e6e6,#0059ff);
      background-size: 300% 100%;
      -webkit-background-clip: text !important;
      background-clip: text !important;
      -webkit-text-fill-color: transparent !important;
      font-weight: bolder;
    }
    @keyframes rainbow { 
        0% { background-position: 100% 0%; }
        100% { background-position: 0% 0%; }
    }
    .claudiamsg {
        align-self: flex-start;
        /* background-color: #ffffff !important; */
    }

    .usermsg {
        align-self: flex-end;
        background-color: #49c2037c !important;
    }
    
    .msganimation{
        animation: slide-top .1s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    }
    @keyframes slide-top {
        0% {
            -webkit-transform: translateY(10px);
                    transform: translateY(10px);
                    opacity: 0;
        }
        100% {
            -webkit-transform: translateY(0px);
                    transform: translateY(0px);
                    opacity: 1;
        }
    }
    .wave {
        position:relative;
        text-align:center;
        margin-left: auto;
        margin-right: auto;
        .dot {
            display:inline-block;
            width: 4px;
            height: 4px;
            border-radius: 50%;
            margin-right: 3px;
            background: #303131;
            animation: wave 1.3s linear infinite;
            &:nth-child(2) {
                animation-delay: -1.1s;
            }
            &:nth-child(3) {
                animation-delay: -0.9s;
            }
        }
    }
    @keyframes wave {
        0%, 60%, 100% {
            transform: initial;
        }

        30% {
            transform: translateY(-15px);
        }
    }
    
</style>
